const state = {
  nama: null,
  prodi: null,
  id: null,
  role: null,
  employee: null,
  email: null,
  userAccess: null,
  currentPeriod: null,
};

const mutations = {
  user_nama: (state, nama) => (state.nama = nama),
  user_prodi: (state, prodi) => (state.prodi = prodi),
  user_id: (state, id) => (state.id = id),
  user_role: (state, role) => (state.role = role),
  user_employee: (state, employee) => (state.employee = employee),
  user_email: (state, email) => (state.email = email),
  user_access: (state, userAccess) => (state.userAccess = userAccess),
  user_current_period: (state, currentPeriod) =>
    (state.currentPeriod = currentPeriod),
};

export default {
  state,
  mutations,
};
